<template>
    <div class="qr-modal">
        <div class="qr-modal__content">
            <div class="qr-modal__header">
                <h2 class="qr-modal__title">Личный QR-код</h2>

                <p class="qr-modal__subtitle">
                    Покажи персональный код при <br />
                    посещении мероприятия
                </p>
            </div>

            <div class="qr-modal__qr-code-container">
                <div class="qr-modal__qr-code-wrapper" v-if="qrToken">
                    <VueQrcode class="qr-modal__qr-code" :value="qrToken" :options="qrCodeOptions" />
                </div>

                <div class="qr-modal__qr-code-wrapper" v-if="error">
                    <VueQrcode class="qr-modal__qr-code" value="invalid data" :options="qrCodeOptions" />
                    <div class="qr-modal__logo-container">
                        <AlertIcon class="qr-modal__logo" />
                    </div>
                </div>
            </div>
            <div class="qr-modal__footer">
                <p class="qr-modal__timer" v-show="timeRemaining >= 0 && !error">
                    Обновить через <span class="qr-modal__time">{{ formattedTime }}</span>
                </p>
                <p class="qr-modal__error" v-if="error">Ошибка загрузки</p>

                <button class="qr-modal__refresh" @click="qrCodeInit">
                    Обновить
                    <img class="qr-modal__refresh-icon" src="~@/assets/images/icons/refresh.svg" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { get } from '@/tools/http';
import { differenceInSeconds } from 'date-fns';
import AlertIcon from '@/components/UI/icons/AlertIcon.vue';
export default {
    name: 'QrModal',
    components: {
        VueQrcode,
        AlertIcon,
    },
    props: {
        logo: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            error: false,
            timeRemaining: 0,
            intervalId: null,
            qrToken: null,
            expiresAtUtc: null,
            nextQrData: null,
            refreshThreshold: 10,
            qrCodeOptions: {
                width: 240,
                errorCorrectionLevel: 'H',
                version: 6,
                color: {
                    dark: '#2A2626',
                },
            },
        };
    },
    computed: {
        formattedTime() {
            const hours = Math.floor(this.timeRemaining / 3600);
            const minutes = Math.floor((this.timeRemaining % 3600) / 60);
            const seconds = this.timeRemaining % 60;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
                2,
                '0'
            )}`;
        },
    },
    methods: {
        startTimer() {
            this.updateTimeRemaining();
            clearInterval(this.intervalId);
            this.intervalId = setInterval(() => {
                if (this.timeRemaining > 0) {
                    this.timeRemaining--;
                } else {
                    clearInterval(this.intervalId);
                }
            }, 1000);
        },
        updateTimeRemaining() {
            const now = new Date();
            if (this.expiresAtUtc) {
                const expiresAt = new Date(this.expiresAtUtc);
                this.timeRemaining = differenceInSeconds(expiresAt, now);
            } else {
                this.timeRemaining = 0;
            }
        },

        async qrCodeInit() {
            const qrData = await this.fetchQrCode();

            if (!qrData) {
                this.error = true;
                return;
            }
            this.error = false;
            this.expiresAtUtc = qrData.expiresAtUtc;
            this.qrToken = qrData.qrCodeId;

            this.startTimer();
        },

        async fetchQrCode() {
            try {
                return await get('checkin', 'api/v1/qr', {}, true);
            } catch (error) {
                console.error(error);
                return null;
            }
        },

        async refreshQrCode() {
            const qrData = await this.fetchQrCode();
            this.nextQrData = qrData;
        },
    },

    watch: {
        timeRemaining(newVal) {
            if (newVal === this.refreshThreshold) {
                this.refreshQrCode();
            }
            if (newVal === 0 && this.nextQrData) {
                this.qrToken = this.nextQrData.qrCodeId;
                this.expiresAtUtc = this.nextQrData.expiresAtUtc;
                this.startTimer();
            }
        },
    },
    mounted() {
        this.qrCodeInit();
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';

.qr-modal {
    padding: mrem(40) 0;
    width: 100%;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;

    @include on-desktop {
        padding: rem(40);
        width: rem(400);
    }

    &__content {
        display: flex;
        width: 100%;
        align-items: center;
        flex-direction: column;
        margin: auto;
    }

    &__title {
        font-size: mrem(22);
        margin-bottom: mrem(30);
        font-weight: 600;
        padding: 0;
        margin: 0;
        text-align: center;

        @include on-desktop {
            font-size: rem(26);
            font-weight: 500;
        }
    }

    &__subtitle {
        font-size: mrem(18);
        margin-bottom: 0;
        font-weight: 500;
        text-align: center;

        @include on-desktop {
            font-size: rem(18);
            line-height: 1.5;
        }
    }

    &__qr-code-container {
        position: relative;
        margin-bottom: 0;
    }

    &__qr-code-wrapper {
        position: relative;
    }

    &__qr-code {
        width: mrem(240);
        height: mrem(240);

        @include on-desktop {
            width: rem(240) !important;
            height: rem(240) !important;
        }
    }

    &__logo-container {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background-color: #ffffffb5;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__logo {
        width: mrem(80);
        height: mrem(80);

        @include on-desktop {
            width: rem(80);
            height: rem(80);
        }
    }

    &__footer {
        display: flex;
        flex-direction: column;
    }

    &__timer {
        font-size: mrem(18);
        font-weight: 500;

        @include on-desktop {
            font-size: rem(18);
        }
    }

    &__error {
        color: #db6c61;
        font-size: mrem(18);

        @include on-desktop {
            font-size: rem(18);
        }
    }

    &__time {
        color: #db6c61;
        font-size: mrem(18);

        @include on-desktop {
            font-size: rem(18);
        }
    }

    &__refresh {
        background: none;
        border: none;
        font-size: mrem(18);
        cursor: pointer;
        font-weight: 500;

        @include on-desktop {
            font-size: rem(18);
        }
    }

    &__refresh-icon {
        width: mrem(19);
        height: mrem(19);
        margin-left: mrem(6);

        @include on-desktop {
            width: rem(19);
            height: rem(19);
            margin-left: rem(6);
        }
    }
}
</style>
